import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '../../GridRenderer/actionRendere'
import {
  calculateGridHeight,
  showNotification,
  customComparator,
} from '@/services/calculate'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import Pagination from '@/components/DynamicComponents/Pagination'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import { createRequest } from '@/services/config'

export default {
  props: ['type'],
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  data: function() {
    const checkLength = (rule, value, callback) => {
      if (String(value).length > 100) {
        callback(
          new Error(
            'Takeoff grouping must be less than or equals to 100 characters',
          ),
        )
      } else {
        callback()
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'takeoffGrouping',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      takeoffGroupingList: [],
      form: {
        id: undefined,
        takeoffGrouping: '',
        isActive: 1,
      },
      rules: {
        takeoffGrouping: [
          {
            required: true,
            message: 'Please enter takeoff grouping',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      gridOptions: null,
      columnDefs: null,
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      isRefresh: this.refresh,
      height: '250px',
      filters: {},
      updateRequest: null,
      requestKeys: ['takeoffGrouping'],
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteTakeoffGrouping', this.deleteTakeoffGrouping)
    this.$root.$on('editTakeoffGrouping', this.getTakeoffGroupingById)
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$on('loadTakeoffGroupings', this.loadTakeoffGroupings)
  },
  beforeDestroy() {
    this.$root.$off('deleteTakeoffGrouping')
    this.$root.$off('editTakeoffGrouping')
    window.removeEventListener('resize', this.getWindowSize)
    this.$root.$off('loadTakeoffGroupings')
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        checkboxCellRender: CheckboxRender,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
      }
      this.columnDefs = [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Takeoff Grouping',
          field: 'takeoffGrouping',
          width: 280,
          sort: 'asc',
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
          headerTooltip: 'Takeoff Grouping',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'Takeoff Grouping',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    // Refresh Takeoff Groupings
    refreshTakeoffGroupings() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.takeoffGroupingList = []
      this.page = 0
      this.defaultSortedBy = 'takeoffGrouping'
      this.defaultSortOrder = true
      this.selectedRowKeys = []
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'takeoffGrouping',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.isRefresh = true
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getTakeoffGroupings(this.tableParams)
    },

    // Delete Takeoff Grouping
    deleteTakeoffGrouping(record) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${record.takeoffGrouping}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this takeoff
              grouping
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Save Takeoff Grouping
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.updateGrouping()
          } else {
            this.addGrouping()
          }
        }
      })
    },

    // Get Takeoff Groupings
    getTakeoffGroupings(params) {
      params.api.sizeColumnsToFit()
      this.tableParams = null
      this.tableParams = params
      const data = params.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = params.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      instance
        .post(projectAPIs.master.takeoffGrouping.list(this.$route.params.id), {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          takeoffGrouping: _.get(this.filters, 'takeoffGrouping', undefined),
        })
        .then(response => {
          this.takeoffGroupingList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'takeoffGroupingTable',
            this.count > this.pageSize,
          )
          this.loading = false
          const searchText = _.get(this.filters, 'takeoffGrouping', undefined)
          if (!searchText) {
            this.$emit(
              'getGroupings',
              this.takeoffGroupingList,
              this.count,
              this.height,
            )
          }
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(
          projectAPIs.master.takeoffGrouping.delete(this.$route.params.id), { data: ids },
        )
        .then(response => {
          showNotification(
            'success',
            'Delete Takeoff Grouping',
            'Takeoff Grouping deleted successfully!',
          )
          this.refreshTakeoffGroupings()
          this.$emit('loadTakeoffGroupings')
        })
        .catch(error => {
          this.loading = false
          this.$notification.open({
            message: 'Delete Takeoff Grouping',
            description: error.response.data.Message,
            icon: <a-icon type="warning" style="color: #fb434a" />,
          })
        })
    },

    cancel() {
      this.form.id = undefined
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Delete All Takeoff Groupings
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected takeoff groupings ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              takeoff groupings
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.isRefresh = true
      this.takeoffGroupingList = []
      if (sortData.length > 0) {
        this.defaultSortedBy =
          this.type !== 'Template'
            ? 'takeoffGrouping'
            : this.type === 'Template'
              ? 'option'
              : 'name'
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy =
          this.type !== 'Template'
            ? 'takeoffGrouping'
            : this.type === 'Template'
              ? 'option'
              : 'name'
        this.defaultSortOrder = true
      }
      this.getTakeoffGroupings(this.tableParams)
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getTakeoffGroupingById(id) {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.spinner = true
      instance
        .get(
          projectAPIs.master.takeoffGrouping.details(this.$route.params.id, id),
        )
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.takeoffGrouping = _.get(
            response.data,
            'result.takeoffGrouping',
            null,
          )
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.spinner = false
          this.updateRequest = _.get(response.data, 'result', null)
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'takeoffGroupingTable',
        this.count > this.pageSize,
      )
      this.gridOptions.api.sizeColumnsToFit()
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.takeoffGroupingList = []
      this.selectedRowKeys = []
      this.getTakeoffGroupings(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.takeoffGroupingList = []
      this.loading = true
      this.page = 0
      this.getTakeoffGroupings(this.gridOptions)
    },

    loadTakeoffGroupings(flag) {
      if (flag) {
        this.$emit('loadTakeoffGroupings')
      }
    },

    // Add takeoff grouping
    addGrouping() {
      this.spinner = true
      instance
        .post(
          projectAPIs.master.takeoffGrouping.add(this.$route.params.id),
          this.form,
        )
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification(
              'warning',
              'Takeoff Grouping',
              response.data.message,
            )
          } else {
            this.visible = false
            showNotification(
              'success',
              'Create Takeoff Grouping',
              'Takeoff Grouping created successfully!',
            )
            this.getTakeoffGroupings(this.tableParams)
            this.$refs.ruleForm.resetFields()
            this.$emit('loadTakeoffGroupings')
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Update takeoff grouping
    updateGrouping() {
      const req = createRequest(
        this.requestKeys,
        this.updateRequest,
        this.form,
      )

      if (!req.isValid) {
        showNotification(
          'info',
          'Update Takeoff Grouping',
          'No changes found to update!',
        )
        return
      }
      this.spinner = true
      instance
        .patch(
          projectAPIs.master.takeoffGrouping.details(
            this.$route.params.id,
            this.form.id,
          ),
          req.request,
        )
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification(
              'warning',
              'Takeoff Grouping',
              response.data.message,
            )
          } else {
            this.visible = false
            showNotification(
              'success',
              'Update Takeoff Grouping',
              'Takeoff Grouping updated successfully!',
            )
            const newData = [...this.takeoffGroupingList]
            const index = newData.findIndex(i => i.id === this.form.id)
            newData[index]['takeoffGrouping'] = this.form.takeoffGrouping
            this.form.id = null
            this.takeoffGroupingList = newData
            this.$refs.ruleForm.resetFields()
            this.$emit('loadTakeoffGroupings')
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },
  },
}
